import * as React from "react";
import { useState, useRef } from "react";

import Carousel from "react-bootstrap/Carousel";

import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { scrollImages, slideImages } from "./walletItems";
import { LimeButton } from "../Buttons/Lime";
import $ from "jquery";

export default function SectionWallet() {
    let [itemIndex, SetItemIndex] = useState(0);
    const carouselRef = useRef();

    function RightBtnClick() {
        carouselRef.current.next();
        if (itemIndex === 3) {
            SetItemIndex(0);
        } else {
            SetItemIndex(itemIndex + 1);
        }

        setAnimation();
    }

    function LeftBtnClick() {
        carouselRef.current.prev();
        setAnimation();
        if (itemIndex === 0) {
            SetItemIndex(3);
        } else {
            SetItemIndex(itemIndex - 1);
        }


    }

    function onIndicatorsClick(eventKey) {
        setAnimation();
        SetItemIndex(eventKey);
    }

    function setAnimation() {
        let wrapper = $(".slide-from-bottom");
        wrapper.addClass("sliderAnimation");
        setTimeout(() => {
            wrapper.removeClass("sliderAnimation");
        }, 800)
    }

    return (
        <section id="wallet-section" className="section_wallet">
            <div className="background-color-black">
                <div
                    data-aos='fade-up'
                    data-aos-duration='1000'
                    className="padding-global">
                    <div className="container-large">
                        <div className="main-container-wallet grid-2">
                            <div className="max-width-full wallet-slider  margin-slider w-tab-content">
                                <Carousel
                                    fade
                                    slide
                                    controls={false}
                                    indicators={true}
                                    onSlide={(eventKey) => {
                                        onIndicatorsClick(eventKey);
                                    }}
                                    touch={true}
                                    ref={carouselRef}
                                    id="walletCarousel"
                                >
                                    {slideImages.map((item, index) => {
                                        return (
                                            <div key={index} className="carousel-item">
                                                <img
                                                    width="auto"
                                                    height="auto"
                                                    src={item.image}
                                                    alt={item.alt}
                                                    loading="lazy" />
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            </div>
                            <div
                                data-current="Tabs"
                                data-easing="ease-out"
                                data-duration-in="300"
                                data-duration-out="100"
                                className="tabs tabs-wallet margin-top w-tabs fade-in-text"
                            >
                                <div className="max-width-small-slider">
                                    <div className="wallet_wrapper-right grid-wallet-content">
                                        <div className="wallet-content ">
                                            <div className="label is-lime grid">
                                                {scrollImages[itemIndex].h1}
                                            </div>
                                            <div className="flex">
                                                <button
                                                    onClick={(e) => {
                                                        LeftBtnClick(e);
                                                    }}
                                                    aria-label="previous"
                                                    title="slide"
                                                    className="slide-arrows left-slide-arrow"
                                                >
                                                    <BiChevronLeft />
                                                </button>
                                                <button
                                                    title="next"
                                                    onClick={(e) => {
                                                        RightBtnClick(e);
                                                    }}
                                                    className="slide-arrows right-slide-arrow"
                                                >
                                                    <BiChevronRight />
                                                </button>
                                            </div>
                                        </div>
                                        <h2 className="heading-style-h2 margin-bottom margin-large slide-from-bottom">
                                            {scrollImages[itemIndex].caption}
                                        </h2>
                                        <p className="text-color-grey wallet-text text-size-large slide-from-bottom">
                                            {scrollImages[itemIndex].text}
                                        </p>
                                        <LimeButton
                                            text={scrollImages[itemIndex].urlText}
                                            url={scrollImages[itemIndex].url}
                                        ></LimeButton>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="main-container-wallet-small grid-2">
                            <div
                                data-current="Tabs"
                                data-easing="ease-out"
                                data-duration-in="300"
                                data-duration-out="100"
                                className="tabs tabs-wallet w-tabs fade-in-text"
                            >
                                <div className="max-width-small-slider">
                                    <div className="wallet_wrapper-right grid-wallet-content-small">
                                        <div className="wallet-content ">
                                            <div className="label is-lime grid">
                                                {scrollImages[itemIndex].h1}
                                            </div>
                                            <div className="flex">
                                                <button
                                                    onClick={(e) => {
                                                        LeftBtnClick(e);
                                                    }}
                                                    aria-label="previous"
                                                    title="slide"
                                                    className="slide-arrows left-slide-arrow"
                                                >
                                                    <BiChevronLeft />
                                                </button>
                                                <button
                                                    title="next"
                                                    onClick={(e) => {
                                                        RightBtnClick(e);
                                                    }}
                                                    className="slide-arrows right-slide-arrow"
                                                >
                                                    <BiChevronRight />
                                                </button>
                                            </div>
                                        </div>
                                        <h2 className="heading-style-h2 margin-bottom margin-large slide-from-bottom">
                                            {scrollImages[itemIndex].caption}
                                        </h2>
                                        <p className="text-color-grey wallet-text text-size-large slide-from-bottom">
                                            {scrollImages[itemIndex].text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="max-width-full wallet-slider w-tab-content">
                                <Carousel
                                    fade
                                    slide
                                    controls={false}
                                    indicators={true}
                                    onSlide={(eventKey) => {
                                        onIndicatorsClick(eventKey);
                                    }}
                                    touch={true}
                                    ref={carouselRef}
                                    id="walletCarousel"
                                >
                                    {slideImages.map((item, index) => {
                                        return (
                                            <div key={index} className="carousel-item">
                                                <img
                                                    width="auto"
                                                    height="auto"
                                                    src={item.image}
                                                    alt={item.alt}
                                                    loading="lazy" />
                                            </div>
                                        );
                                    })}
                                </Carousel>
                                <LimeButton
                                    text={scrollImages[itemIndex].urlText}
                                    url={scrollImages[itemIndex].url}
                                ></LimeButton>
                            </div>
                        </div>
                    </div>
                    <p
                        className="
                            margin-top
                            max-width-large
                            text-desktop-mobile
                            align-center paragraph24
                            text-color-grey"
                    >
                        {scrollImages[itemIndex].h4}&nbsp;
                        {/* <Link
                                href={'#'}
                                to={'changex_card'}
                                smooth={true}
                                className="transparent text-style-link paragraph24">
                                {heroObj.titleObj.titleWithLink}
                            </Link> */}
                    </p>
                </div>
            </div>
        </section>
    );
}
